import reactUseCookie from "react-use-cookie";

import {apiUrl} from "../../api/baseURL";
import Icon from "../../Components/Icon/Icon";
import venezialogo from "../../images/icons/veneziaOfficeLogo2.png";

export const ROUTE_IDS_NOT_DELETABLE = Object.freeze([1, 2, 4, 5, 7, 9, 10, 13, 15]);

export const ROUTE_NAMES = Object.freeze({
  CASHDESK: "Cashdesk",
});

export const FEA_MANAGERS_POSITIONS_IDS = Object.freeze([1, 4, 7]);
export const CO_MANAGERS_POSITIONS_IDS = Object.freeze([1, 3, 7]);
export const LOGIST_MANAGERS_POSITIONS_IDS = Object.freeze([2, 5, 7]);
export const SUPER_USER_POSITION_ID = 7;

export const ADVANCE_PROCENT = 70;

export const CO_STATUSES = Object.freeze({
  CREATED: 1,
  ACTIVE: 2,
  DONE: 3,
  ONPAYMENT: 4,
  PAIDINADVANCED: 5,
  MAIN: 6,
  PAID: 7,
});

export const BALANCE_SHEET_ACCOUNT_TYPES = Object.freeze({
  CLIENT_ACCOUNT: 2620,
  CO_ACCOUNT: 2621,
  BLOCKING_FOR_CO_ACCOUNT: 2622,
  CASHLESS_CLIENT_ACCOUNT: 2699,
  EQUIVALENT_CURRENCY_POSITION: 3800,
});

export const ACCOUNT_TYPES = [
  {value: "external", title: "External"},
  {value: "internal", title: "Internal"},
  {value: "payer", title: "Payer"},
];

export const ICON_NAMES = Object.freeze({
  ALERT: "icon-alert-circle",
  ALERT_SQUARE: "icon-exclamation-square",
  ALERT_TRIANGLE: "icon-warning",
  HELP: "icon-help-circle",
  QUESTION_SQUARE: "icon-question-square",
  INFO: "icon-info",
  CASE: "icon-briefcase",
  FILE: "icon-file",
  FILE_TEXT: "icon-file-text",
  CLIPBOARD: "icon-clipboard",
  CALENDAR: "icon-calendar",
  SHEVRON: "icon-chevron",
  CALCULATOR: "icon-calculator",
  CLOCK: "icon-clock",
  SHEVRON_LEFT: "icon-chevron-left",
  SHEVRON_RIGHT: "icon-chevron-right",
  SHEVRONS_LEFT: "icon-chevrons-left",
  SHEVRONS_RIGHT: "icon-chevrons-right",
  DOWNLOAD_CLOUD: "icon-download-cloud",
  UPLOAD_CLOUD: "icon-upload-cloud",
  EDIT: "icon-edit",
  EDIT_PENCIL: "icon-edit-3",
  RETURN: "icon-return",
  SAVE: "icon-save",
  TRASH: "icon-trash",
  EYE: "icon-eye",
  EYE_OFF: "icon-eye-off",
  PAPER_CLIP: "icon-paperclip",
  PRINTER: "icon-printer",
  FILTER_ON: "icon-Filter_On-Vector",
  FILTER_OFF: "icon-Filter_Off-Vector",
  TRUCK_PENDING: "icon-truck-1",
  CARGO_TRUCK: "icon-truck-2",
  PACKAGE_READY: "icon-package",
  CHECK: "icon-check",
  CIRCLE: "icon-circle",
  CHECK_CIRCLE: "icon-check-circle",
  SNOW: "icon-snow",
  MONEY: "icon-money",
  DOC_ERROR: "icon-document-error",
  STATUS_WARNING: "icon-document-error",
  STAR: "icon-star",
  PAPERCLIP: "icon-attach-paperclip",
  EXPAND: "icon-expand-arrows",
  PDF_FILE: "icon-file-pdf",
  RADIO: "icon-radio",
  RADIO_ACCEPT: "icon-radio-accept",
  DOUBLE_PLUS: "icon-double-plus",
  PLUS_SQUARE: "icon-plus-square",
  PLUS_CIRCLE: "icon-plus-circle",
  CROSS_CLOSE: "icon-close",
  CROSS: "icon-cross",
  CROSS_SOLID: "icon-close-solid",
  CHECKMARK: "icon-checkmark",
  HAND: "icon-hand",
  IMG: "icon-img",
  ADD_IMG: "icon-add-img",
  SAVED: "icon-saved",
  EXTERNAL_LINK: "icon-external-link",
  LINK: "icon-link",
  UNLINK: "icon-unlink",
  SHARE: "icon-share",
  LOGOUT: "icon-logout",
  LOGO: "icon-logo",
  READY: "icon-ready",
  SETTING: "icon-setting",
  CHANGE_LOG: "icon-notes-book",
  RATE_MATRIX: "icon-rate-matrix",
  DOCS_PAGE: "icon-doc-page",
  BUY: "icon-buy",
  SELL: "icon-sell",
});

export const ROLES = Object.freeze({FEA_MANAGER: 1, SUPER_USER: 7, SENIOR_CASHIER: 9});

export const COF_STATES = Object.freeze({
  HAS_DIRECTIVE: <Icon name={ICON_NAMES.CHECK} className="icon-fill" width={12} height={12} />,
  FROZEN: <Icon name={ICON_NAMES.SNOW} className="icon-fill" width={16} height={16} />,
  PAID: <Icon name={ICON_NAMES.MONEY} className="icon-fill" width={15} height={15} />,
});

export const PAYMENT_STATES = Object.freeze({
  HAS_DIRECTIVE: <Icon name={ICON_NAMES.FILE_TEXT} className="icon-fill" width={15} height={15} />,
  PAID: <Icon name={ICON_NAMES.MONEY} className="icon-fill" width={15} height={15} />,
});

export const TP_STATES = Object.freeze({
  // CREATED
  1: {icon: ICON_NAMES.PACKAGE_READY, text: "Created"},
  // IN_WORK
  2: {icon: ICON_NAMES.TRUCK_PENDING, text: "In work"},
  // IN_TRANSFER
  3: {icon: ICON_NAMES.CARGO_TRUCK, text: "In transfer"},
});

export const SALE_TYPES = Object.freeze(["Fabrication", "Packaging", "Roll", "Sack", "Jar"]);

export const UNITS = Object.freeze({PIECES: 1, SQ_M: 2, KG: 3, LOADING_M: 4, PACKAGE: 5, ROLL: 6, SACK: 7, CAN: 8});
const isTest = apiUrl.includes("test");
export const IT_MANAGERS_IDS_TEST = Object.freeze([2, 33, 42, 43, 44, 45]);
export const IT_MANAGERS_IDS = Object.freeze(isTest ? IT_MANAGERS_IDS_TEST : [2, 33, 42, 43, 45, 46]);
export const findIfUserIsITManager = user => IT_MANAGERS_IDS.includes(user?.id);

export const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
export const findIfEmailIsValid = email => !!email && email.match(isValidEmail);

export const ORG_STRUCTURES_INFO = Object.freeze({
  //NOK
  1: {
    cite: "venezia.com.ua",
    city: "Kyiv, Ukraine",
    street: "Velyka Vasylkivska St., 13/1",
    logo: venezialogo,
  },
  DEFAULT: {
    cite: "venezia.com.ua",
    city: "Kyiv, Ukraine",
    street: "Velyka Vasylkivska St., 13/1",
    logo: venezialogo,
  },
});

export const uploadFileState = <Icon name={ICON_NAMES.FILE_TEXT} height={16} width={14} className="icon-fill" />;
export const addedFileSymbol = <Icon name={ICON_NAMES.PAPERCLIP} height={16} width={14} className="icon-fill" />;
export const addedFileRowSymbol = "✓";

//for pdfMaker to adjust big length cells (если в колонке, например описания, очень много символов, то этот рядок не отображался и был белый пробел до следующей страницы)
export const cellAdapt = {
  A4: cellLength => {
    if (cellLength < 500) {
      return {sliceTo: cellLength, fontSize: 7};
    }
    if (cellLength < 700) {
      return {sliceTo: cellLength, fontSize: 6.5};
    }
    if (cellLength < 900) {
      return {sliceTo: cellLength, fontSize: 5.5};
    }

    return {sliceTo: 1200, fontSize: 5};
  },
  A3: cellLength => {
    if (cellLength < 900) {
      return {sliceTo: cellLength, fontSize: 7};
    }
    if (cellLength < 1200) {
      return {sliceTo: cellLength, fontSize: 6};
    }
    if (cellLength < 1600) {
      return {sliceTo: cellLength, fontSize: 5};
    }

    return {sliceTo: 1800, fontSize: 4};
  },
};

export const getImageSize = url => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = url;

    img.onload = () => {
      resolve({width: img.width, height: img.height, widthHeightCoef: img.width / img.height});
    };

    img.onerror = reject;
  });
};

export const imgcellRender = value => {
  var imgs = value.getValue();
  if (imgs) {
    return (
      <div style={{display: "flex", flexDirection: "row", justifyContent: "center"}}>
        <div key={imgs} style={{position: "relative"}}>
          <img src={apiUrl + "/" + imgs} alt={imgs} style={{width: "14rem", height: "14rem", marginRight: "2px"}} />
        </div>
      </div>
    );
  }
};

export const imgCellRenderByUrl = url => {
  if (!url) return <></>;

  return (
    <div style={{display: "flex", flexDirection: "row", justifyContent: "center"}}>
      <div key={url} style={{position: "relative"}}>
        <img src={apiUrl + "/" + url} alt={url} style={{width: "14rem", height: "14rem", marginRight: "2px"}} />
      </div>
    </div>
  );
};

export const pdfStyles = {
  tableHeader: {
    bold: true,
    fontSize: 10,
    color: "black",
    alignment: "center",
  },
  cell: {
    fontSize: 9,
    color: "black",
    alignment: "left",
  },
  justy: {
    alignment: "center",
  },
  nestedTable: {
    margin: [20, 0, 0, 0],
    alignment: "left", // Убираем отступы внутри ячейки с вложенной таблицей
  },
  header: {
    bold: true,
    fontSize: 9,
  },
  headerH1: {
    bold: true,
    fontSize: 16,
    alignment: "center",
    margin: [0, 10, 0, 0],
  },
  headerH2: {
    bold: true,
    fontSize: 14,
    alignment: "center",
    margin: [0, 10, 0, 5],
  },
  simpletext: {
    margin: [0, 5, 0, 0],
  },
  emptyRow: {
    lineHeight: 2,
    color: "white",
  },
};

export class LocalStorageManager {
  constructor(name) {
    this.name = name;
    try {
      this.item = JSON.parse(localStorage.getItem(name));
    } catch (error) {
      console.error(error);
    }
  }

  getItem() {
    return JSON.parse(localStorage.getItem(this.name));
  }

  setItem(item) {
    localStorage.setItem(this.name, JSON.stringify(item));
  }

  clearItem() {
    this.name = null;
    localStorage.setItem(this.name, null);
  }
}

export class SessionStorageManager {
  constructor(name) {
    this.name = name;
    try {
      this.item = JSON.parse(sessionStorage.getItem(name));
    } catch (error) {
      console.error(error);
    }
  }

  getItem() {
    try {
      return JSON.parse(sessionStorage.getItem(this.name));
    } catch (error) {
      console.error(error);
    }
  }

  setItem(item) {
    try {
      sessionStorage.setItem(this.name, JSON.stringify(item));
    } catch (error) {
      console.error(error);
    }
  }

  setItemWithPrev(func) {
    const item = func(this.item);

    try {
      sessionStorage.setItem(this.name, JSON.stringify(item));
    } catch (error) {
      console.error(error);
    }
  }

  clearItem() {
    try {
      this.name = null;
      sessionStorage.setItem(this.name, null);
    } catch (error) {
      console.error(error);
    }
  }
}

export const findIfTokenExpired = () => {
  const tokenLifespan = 12 * 60 * 60 * 1000; // 12 hours in milliseconds
  // const tokenLifespan = 5 * 1000;

  const loginTimeManager = new LocalStorageManager("login_time");
  const loginTime = loginTimeManager.getItem();

  return !loginTime || Date.now() > +loginTime + tokenLifespan;
};

export class CookieManager {
  constructor(name, options = {}) {
    this.name = name;
    this.options = options;

    const [cookie, setCookie, removeCookie] = reactUseCookie(name, "0", this.options);
    this.cookie = cookie;
    this.setCookie = setCookie;
    this.removeCookie = removeCookie;
  }

  getItem() {
    return this.cookie;
  }

  setItem(item) {
    this.setCookie(item, this.options);
  }

  clearItem() {
    this.name = null;
    this.removeCookie();
  }
}

export const ERROR = Object.freeze({
  TOKEN: "No token or token expired",
  CANCELED: "ERR_CANCELED", //canceled request via AbortController
});
export const formDocNumberFromFileName = fileName => {
  return fileName?.slice(0, fileName.lastIndexOf("."));
};

export const EUR_CURRENCY_ID = 978;
export const EUR_CURRENCY_SYMBOL = "\u20AC";
export const UAH_CURRENCY_ID = 980;

export const formFileUrlFromFile = file => `${file.fileUrl}${file.deletedAt ? "|DELETED" : ""}`;

export const formFileUrlFromFileString = file => file?.split("|DELETED")?.[0];

export const print = url => {
  if (!url) return;

  const iframe = document.createElement("iframe");
  iframe.style.display = "none"; // Скрываем от пользователя
  document.body.appendChild(iframe);

  // Пишем в iframe HTML с картинкой
  iframe.contentDocument.write(`
    <html>
      <body style="margin:0;">
        <img src="${url}" style="width:100%;" onload="window.print();">
      </body>
    </html>
  `);
  iframe.contentDocument.close();

  // Удаляем iframe после того, как окно печати закроется
  iframe.contentWindow.onafterprint = () => document.body.removeChild(iframe);
};

export const formTranslation = (item, language) => {
  if (!item) return "";
  const itemKeys = Object.keys(item);
  const engNaming = itemKeys.includes("engName") ? "engName" : itemKeys.includes("nameEng") ? "nameEng" : "name";
  const ukrNaming = itemKeys.includes("ukrName") ? "ukrName" : itemKeys.includes("nameUkr") ? "nameUkr" : "name";

  if (language === "en") {
    return item?.[engNaming] || `${item?.[ukrNaming]} (translation missing)`;
  }

  return item?.[ukrNaming] || `${item?.[engNaming]} (немає перекладу)`;
};

export const findOutRate = ({currencyId, allRates}) => {
  if (!currencyId || !allRates) return "";

  return currencyId === EUR_CURRENCY_ID
    ? 1
    : allRates?.find(({currencyId: rateCurrencyId}) => rateCurrencyId === currencyId)?.saleRate || "";
};

export const detectTextLanguage = text => {
  if (/[а-яіїєґ]/i.test(text)) return "uk";
  if (/[a-z]/i.test(text)) return "en";
  return null;
};

export const IMAGE_TYPE_SKU_PLAN = Object.freeze({
  IMAGE: "image",
  DRAWING: "drawing",
  COLOR: "color",
  DECOR: "decor",
  OVERALL: "overall",
});
